/******************************************************************************************
 *	Region Code to language mapping service
 *******************************************************************************************
 *
 * Maps region codes to languages for products
 * Wiki: https://wiki.corp.adobe.com/display/Antipiracy/Country+To+Region+Mapping
 *
 */
(function() {
  

  angular.module('rcServices.regionCodeToLang', []).service('regionCodeToLang', function(_) {
    var regions = {
      chn: 'global.productLanguages.chn',
      en: 'global.productLanguages.en',
      euw: 'global.productLanguages.euw',
      jpl: 'global.productLanguages.jpl',
      mau: 'global.productLanguages.mau',
      mua: 'global.productLanguages.mua',
      mue: 'global.productLanguages.mue',
      mult: 'global.productLanguages.mult',
      mun: 'global.productLanguages.mun',
      mus: 'global.productLanguages.mus'
    };

    this.get = function(regionCode) {
      regionCode = regionCode ? _.toLower(regionCode) : null;
      return (regionCode && regions[regionCode]) || null;
    };
  });
})();
